/* eslint-disable class-methods-use-this */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import { Box } from 'components/ui';
import ComponentList from 'components/Content/ComponentList';
import contentConstants from 'constants/content';
import BeautyInsiderModules from 'components/Content/BeautyInsider/BeautyInsiderModules';
import ProfileBanner from 'components/ProfileBanner';
import BeautyInsiderSummary from 'components/Content/BeautyInsider/BeautyInsiderSummary';
import beautyInsiderPageBindings from 'analytics/bindingMethods/pages/beautyInsider/beautyInsiderPageBindings';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import userActions from 'actions/UserActions';
import store from 'store/Store';
import { refreshBasket } from 'actions/RwdBasketActions';

const { CONTEXTS } = contentConstants;
const PASSKEY_RESET_FLAG = 'passkeyResetRedirect';

class BeautyInsider extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            isAccessTokenPresent: false,
            hasHandledPasskeyFlag: false
        };
    }

    fetchUserData = profileId => {
        const {
            fetchClientSummary, fetchRecentlyRedeemedRewards, getAccountHistorySlice, getAccountActivityPoints, isActivityGroupingEnabled
        } =
            this.props;

        fetchClientSummary(true);
        fetchRecentlyRedeemedRewards(profileId);

        if (isActivityGroupingEnabled) {
            getAccountActivityPoints(profileId);
        } else {
            getAccountHistorySlice();
        }
    };

    triggerAnalytics = () => {
        const { isAtLeastRecognized } = this.props;
        beautyInsiderPageBindings.setPageLoadAnalytics(isAtLeastRecognized);
    };

    tryPasskeyOptinAfterReset = async () => {
        const { user, showPasskeyOptinModal } = this.props;
        const { hasHandledPasskeyFlag } = this.state;

        if (hasHandledPasskeyFlag || !user?.isInitialized) {
            return;
        }

        const resetFlag = Storage.session.getItem(PASSKEY_RESET_FLAG, false, true);

        if (!resetFlag) {
            return;
        }

        Storage.session.removeItem(PASSKEY_RESET_FLAG);

        const email = user.login;

        this.setState({ hasHandledPasskeyFlag: true });

        const shouldShowPasskey = await userActions.shouldShowPasskeyOptin(
            { login: email },
            Sephora.configurationSettings?.passkey?.optInResetPwd?.isEnabled
        );

        if (shouldShowPasskey) {
            showPasskeyOptinModal({
                isOpen: true,
                email,
                passkeyType: 'optinCreate',
                placement: 'reset password'
            });
        }
    };

    componentDidMount() {
        const { fetchBeautyOffers, fetchBiRewards, user } = this.props;
        const { country, language } = Sephora.renderQueryParams;
        const isAccessTokenPresent = !!Storage.local.getItem(LOCAL_STORAGE.AUTH_ACCESS_TOKEN);
        this.setState({ isAccessTokenPresent });

        fetchBeautyOffers(country, language);

        if (user.isInitialized && user.profileId) {
            this.fetchUserData(user.profileId);
            this.triggerAnalytics();
        }

        const { isInitialized, defaultSACountryCode, defaultSAZipCode } = user;
        const saDataReady = Boolean(isInitialized && isAccessTokenPresent && defaultSACountryCode && defaultSAZipCode);

        if (saDataReady) {
            fetchBiRewards();
        }

        this.tryPasskeyOptinAfterReset();
    }

    componentDidUpdate(prevProps) {
        const { user, fetchBiRewards, isAnonymous } = this.props;
        const { isInitialized } = user;
        const { isAccessTokenPresent } = this.state;

        if (user.profileId !== prevProps.user.profileId) {
            this.fetchUserData(user.profileId);
        }

        if (isInitialized && prevProps.isAnonymous && !isAnonymous) {
            store.dispatch(refreshBasket());
        }

        const defaultSADataChanged =
            user.defaultSACountryCode !== prevProps.user.defaultSACountryCode || user.defaultSAZipCode !== prevProps.user.defaultSAZipCode;

        if (user.isInitialized && defaultSADataChanged && isAccessTokenPresent) {
            fetchBiRewards();
        }

        if (user.isInitialized && prevProps.user.isInitialized !== user.isInitialized) {
            this.triggerAnalytics();
        }

        if (user.isInitialized && (!prevProps.user.isInitialized || user.login !== prevProps.user.login)) {
            this.tryPasskeyOptinAfterReset();
        }
    }

    hardCodedModules = () => {
        return (
            <>
                <BeautyInsiderModules user={this.props.user} />
            </>
        );
    };

    renderContentZone = content => {
        return (
            <ComponentList
                enablePageRenderTracking={true}
                trackingCount={1}
                context={CONTEXTS.CONTAINER}
                removeLastItemMargin={true}
                removeFirstItemMargin={true}
                items={content}
            />
        );
    };

    signedInUserSection = (topContent, bottomContent) => {
        return (
            <Box marginTop={5}>
                <BeautyInsiderSummary />
                <Box marginTop={[6, 7]}>{this.renderContentZone(topContent)}</Box>
                <Box>{this.hardCodedModules()}</Box>
                <Box marginTop={[6, 7]}>{this.renderContentZone(bottomContent)}</Box>
            </Box>
        );
    };

    notSignedInUserSection = bottomContent => {
        return <Box marginTop={[6, 7]}>{this.renderContentZone(bottomContent)}</Box>;
    };

    render() {
        const { userIsInitialized, isAtLeastRecognized, content } = this.props;

        return (
            <>
                <ProfileBanner origin='beautyInsider' />
                {!userIsInitialized
                    ? null
                    : isAtLeastRecognized
                        ? this.signedInUserSection(content.topContent, content.bottomContent)
                        : this.notSignedInUserSection(content.bottomContent)}
            </>
        );
    }
}

export default wrapComponent(BeautyInsider, 'BeautyInsider');
